import { useEffect, useRef } from 'react'
import { useAuthContext } from '../hooks/authContext'
import { identifyHubSpot } from '../utils/hubspot'

// Pushes a HubSpot `identify` call whenever an authenticated user's email becomes
// available (or changes). This is the SPA equivalent of the ASP.NET
// `@if (User.Identity.IsAuthenticated) { _hsq.push(['identify', ...]) }` block.
//
// Rendered app-wide inside the AuthProvider (see gatsby-browser.js) so it covers
// every page regardless of layout, and re-fires when a user signs in/out via SSO.
// Renders nothing.
const HubSpotTracker = () => {
  const { user } = useAuthContext()
  const lastIdentifiedRef = useRef(null)

  useEffect(() => {
    const email = user?.email
    if (!email || email === lastIdentifiedRef.current) return
    lastIdentifiedRef.current = email
    identifyHubSpot(email)
  }, [user])

  return null
}

export default HubSpotTracker
